export const studyMaterials = [
  {
    id: 1,
    title: 'JEE Main Complete Study Material',
    class: 'Class 11 & 12',
    includes: 'Physics, Chemistry, Mathematics',
    format: 'Printed + PDF',
    price: '₹4,999'
  },
  {
    id: 2,
    title: 'NEET Study Material',
    class: 'Class 11 & 12',
    includes: 'Physics, Chemistry, Biology',
    format: 'Printed + PDF',
    price: '₹4,499'
  }
];

export const testSeries = [
  {
    id: 1,
    title: 'JEE Main Online Test Series',
    tests: '25 Full Tests',
    mode: 'Online',
    price: '₹1,999'
  },
  {
    id: 2,
    title: 'JEE Advanced Test Series',
    tests: '15 Advanced Level Tests',
    mode: 'Online + Offline',
    price: '₹2,499'
  }
];
